import "./Popup.scss";

import React from "react";

class Popup extends React.Component {
  render() {
    const {
      title,
      text,
      rows,
      buttons,
      onClickClose,
      showCloseButton = true,
    } = this.props;
    return (
      <div className="popup">
        <div className="popup__box">
          {showCloseButton && (
            <div className="popup__close-btn" onClick={onClickClose} />
          )}
          {title && <h2 className="popup__title">{title}</h2>}
          {text && <p className="popup__text">{text}</p>}
          {rows && (
            <p className="popup__textrows">
              {rows.map((row) => {
                return <div className="popup__textrow">{row}</div>;
              })}
            </p>
          )}
          {buttons && <div className="popup__buttons">{buttons}</div>}
        </div>
      </div>
    );
  }
}

export default Popup;
